// extracted by mini-css-extract-plugin
export const wordmark = "Wordmark-module--wordmark--2vZsO";